import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { MovimientosEntity } from "../entities/movimientos_entity";

@Pipe({
    name: "dataFilterMovimiento"
})
export class DataFilterPipe implements PipeTransform {

    transform(array: MovimientosEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.NumeroMovimiento+"").indexOf((query)) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterTipo"
})
export class DataFilterPipe2 implements PipeTransform {

    transform(array: MovimientosEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.TipoMovimiento+"").indexOf((query)) > -1);
        }
        return array;
    }
}

@Pipe({
    name: "dataFilterEstado"
})
export class DataFilterPipe3 implements PipeTransform {

    transform(array: MovimientosEntity[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.Estado+"").indexOf((query)) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/movimientos/movimientos.filter.ts